/**
 * Application Entry Point
 * Bulletproof React Pattern
 *
 * Minimal entry point that:
 * - Initializes fonts and preconnects
 * - Sets up Sentry monitoring (async)
 * - Renders the App component
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@/providers';
import { App } from './app';
import { initSentry } from './lib/sentry';
import { injectOpenDyslexicFonts, injectSupabasePreconnect } from './config/fonts';
import './styles/index.css';
import './components/errors/error-boundary.css';

// Initialize fonts and preconnects
injectSupabasePreconnect();
injectOpenDyslexicFonts();

// Initialize Sentry asynchronously (non-blocking)
initSentry();

// Get root element
const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

// Create React root and render
const root = createRoot(container);

root.render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>
);
